import { AbstractControl } from '@angular/forms';
import { ParkingTariffTieredPriceDTO } from 'src/app/base/models/models.swagger.generated';

export class TariffDetailsPriceValidators {
  public static assertMaxParkingTimeCoverageOfTieredPrices(c: AbstractControl) {
    const maxParkingDurationControl = c.parent?.parent?.get('general')?.get('maxParkingDurationInMinForm');
    const daysControl = maxParkingDurationControl?.get('days');
    const hoursControl = maxParkingDurationControl?.get('hours');
    const minutesControl = maxParkingDurationControl?.get('minutes');
    if (!daysControl || !hoursControl || !minutesControl) {
      return {invalidFormStructure: true};
    }
    const maxParkingDuration = ((daysControl.value ?? 0) * 24 + (hoursControl.value ?? 0)) * 60 + (minutesControl.value ?? 0);
    const tieredPrices: ParkingTariffTieredPriceDTO[] = c.value;
    if (maxParkingDuration) {
      let coveredDuration = 0;
      if (tieredPrices && tieredPrices.length > 0) {
        tieredPrices.forEach(t => {
          coveredDuration += t.amountOfMinutes;
        });
      }
      if (maxParkingDuration > coveredDuration) {
        return {assertMaxParkingTimeCoverageOfTieredPricesFailed: true};
      }
    } else {
      if (!tieredPrices || tieredPrices.length <= 0) {
        return {noTieredPricesSet: true};
      }
    }
    return null;
  }
}
